import {FxeQuizQuestionController} from "./FxeQuizQuestionController";
import {EXPIRATION_EXERCISE_ASSIGNMENT_3} from "../FxeQuizQuestions";
import {UserConfig} from "../../../types/UserConfig";
import {CurrentUserService} from "../../../services/user/CurrentUserService";

export const ExpirationExerciseAssignment3 = "tfExpirationExerciseAssignment3Question";

export function expirationExerciseAssignment3() {
    return {
        templateUrl: "app/quiz/fxe/questions/ExpirationExerciseAssignment3.html",
        bindings: {
            previousAnswer: "<",
            onAnswer: "&"
        },
        controllerAs: "ctrl",
        controller: ExpirationExerciseAssignment3Controller
    };
}

export class ExpirationExerciseAssignment3Controller extends FxeQuizQuestionController {
    public config = EXPIRATION_EXERCISE_ASSIGNMENT_3;
}
